import { LobbyImage } from '@colonist/types';
import { createDivIn, createImgIn, createParagraphIn, setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { AnalyticEventCategory, AnalyticEventType, GiftingFlowAnalytics } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../analytics/Analytics.ts';
export class UIStoreGiftBaseSelectionController {
    createSidebarButton() {
        this.topNavigationButton = createDivIn(this.sidebarContainer, 'store-gift-sidebar-button');
        const childCount = this.sidebarContainer.children.length;
        this.tabOrderNumberContainer = createDivIn(this.topNavigationButton, 'store-gift-sidebar-order-number');
        this.tabOrderNumber = createParagraphIn(this.tabOrderNumberContainer, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: `${childCount}`
            }
        }, '');
        this.checkmark = createImgIn(this.tabOrderNumberContainer, LobbyImage.CheckMark, 'store-gift-sidebar-checkmark');
        this.checkmark.classList.add('hidden');
        this.selectionTitle = createDivIn(this.topNavigationButton, 'store-gift-sidebar-title');
    }
    select() {
        var _this_titleAndContentContainer;
        for (const child of this.parentDiv.children)child.classList.add('hidden');
        for (const child of this.sidebarContainer.children)child.classList.remove('selected');
        this.topNavigationButton.classList.add('selected');
        (_this_titleAndContentContainer = this.titleAndContentContainer) === null || _this_titleAndContentContainer === void 0 ? void 0 : _this_titleAndContentContainer.classList.remove('hidden');
    }
    makePageFirst() {
        this.parentDiv.prepend(this.titleAndContentContainer);
        this.sidebarContainer.prepend(this.topNavigationButton);
        let tabNumber = 1;
        for (const child of this.sidebarContainer.children){
            if (child.classList.contains('store-gift-sidebar-button')) {
                const tabOrderNumber = child.querySelector('.store-gift-sidebar-order-number p');
                if (tabOrderNumber) tabOrderNumber.textContent = `${tabNumber}`;
                tabNumber += 1;
            }
        }
    }
    selectNextPage() {
        UIStoreGiftBaseSelectionController.sendGiftFlowAnalytics(GiftingFlowAnalytics.SuccessfulPageCompletion);
        this.titleAndContentContainer.classList.add('hidden');
        this.topNavigationButton.classList.remove('selected');
        this.markAsCompleted(true);
        const nextPageContent = this.titleAndContentContainer.nextElementSibling;
        const nextSidebarButton = this.topNavigationButton.nextElementSibling;
        nextPageContent === null || nextPageContent === void 0 ? void 0 : nextPageContent.classList.remove('hidden');
        nextSidebarButton === null || nextSidebarButton === void 0 ? void 0 : nextSidebarButton.classList.add('selected');
    }
    markAsCompleted(isCompleted) {
        if (isCompleted) {
            this.tabOrderNumberContainer.classList.add('completed');
            this.tabOrderNumber.classList.add('hidden');
            this.checkmark.classList.remove('hidden');
        } else {
            this.tabOrderNumberContainer.classList.remove('completed');
            this.tabOrderNumber.classList.remove('hidden');
            this.checkmark.classList.add('hidden');
        }
    }
    enableNextButton() {
        var _this_mainCTAButton;
        (_this_mainCTAButton = this.mainCTAButton) === null || _this_mainCTAButton === void 0 ? void 0 : _this_mainCTAButton.classList.remove('disabled');
    }
    disableNextButton() {
        var _this_mainCTAButton;
        (_this_mainCTAButton = this.mainCTAButton) === null || _this_mainCTAButton === void 0 ? void 0 : _this_mainCTAButton.classList.add('disabled');
    }
    createPageContent() {
        this.titleAndContentContainer = createDivIn(this.parentDiv, 'store-gift-page-container');
        this.pageTitle = createDivIn(this.titleAndContentContainer, 'store-gift-page-title');
        const backButton = createImgIn(this.pageTitle, LobbyImage.LeftArrow);
        setElementOnClick(backButton, ()=>this.selectPreviousPage());
        this.pageContainer = createDivIn(this.titleAndContentContainer, 'store-gift-page-content');
    }
    createNextButton() {
        const nextButton = createDivIn(this.pageContainer, 'store-gift-overlay-main-cta-button');
        createParagraphIn(nextButton, {
            key: 'strings:storePage.sections.giftOverlay.recipientSelection.next'
        }, '');
        setElementOnClick(nextButton, ()=>{
            if (nextButton.classList.contains('disabled')) return;
            this.selectNextPage();
        });
        nextButton.classList.add('disabled');
        return nextButton;
    }
    createCheckoutButton() {
        const checkoutButton = createDivIn(this.pageContainer, 'store-gift-overlay-main-cta-button');
        createParagraphIn(checkoutButton, {
            key: 'strings:storePage.checkout.checkout'
        }, '');
        setElementOnClick(checkoutButton, ()=>{
            if (checkoutButton.classList.contains('disabled')) return;
            this.checkoutAction();
        });
        return checkoutButton;
    }
    selectPreviousPage() {
        var _this_hideGiftOverlayAction, _this;
        const previousPageContent = this.titleAndContentContainer.previousElementSibling;
        const previousSidebarButton = this.topNavigationButton.previousElementSibling;
        if (!previousPageContent || !previousSidebarButton) return (_this_hideGiftOverlayAction = (_this = this).hideGiftOverlayAction) === null || _this_hideGiftOverlayAction === void 0 ? void 0 : _this_hideGiftOverlayAction.call(_this);
        this.titleAndContentContainer.classList.add('hidden');
        this.topNavigationButton.classList.remove('selected');
        previousPageContent === null || previousPageContent === void 0 ? void 0 : previousPageContent.classList.remove('hidden');
        previousSidebarButton === null || previousSidebarButton === void 0 ? void 0 : previousSidebarButton.classList.add('selected');
    }
    static sendGiftFlowAnalytics(analytic) {
        const giftButtonClickEventData = {
            type: AnalyticEventType.GiftingFlowAnalytic,
            category: AnalyticEventCategory.GiftMembershipOverlay,
            floatValue: analytic
        };
        void CA.sendAnalyticEvent(giftButtonClickEventData);
    }
    constructor(parentDiv, sidebarContainer, hideGiftOverlayAction, checkoutAction){
        this.parentDiv = parentDiv;
        this.hideGiftOverlayAction = hideGiftOverlayAction;
        this.sidebarContainer = sidebarContainer;
        this.createSidebarButton();
        this.createPageContent();
        setElementOnClick(this.topNavigationButton, ()=>this.select());
        this.checkoutAction = checkoutAction;
    }
}
